import { App } from '@/App';
import { enforceCrazyGamesSitelock } from '@/sdk/sitelock';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@/index.css';

if (import.meta.env.VITE_PLATFORM === 'crazygames' && !enforceCrazyGamesSitelock()) {
  // Sitelock failed; renderBlockedScreen has replaced document.body — abort boot.
} else {
  const root = document.getElementById('app');
  if (!root) {
    throw new Error('Root element #app not found');
  }

  createRoot(root).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}
